export const sideMenuTranslations = {
  general: {
    key: 'sideMenu.general',
    defaultValue: 'General',
  },
  storePerformanceInsights: {
    key: 'sideMenu.storePerformanceInsights',
    defaultValue: 'Store Performance Insights',
  },
  dashboards: {
    key: 'sideMenu.dashboards',
    defaultValue: 'Dashboards',
  },
  home: {
    key: 'sideMenu.home',
    defaultValue: 'Home',
  },
  widgets: {
    key: 'sideMenu.widgets',
    defaultValue: 'Widgets',
  },
  avatarManagement: {
    key: 'sideMenu.avatarManagement',
    defaultValue: 'Avatar Management',
  },
  transaction: {
    key: 'sideMenu.transaction',
    defaultValue: 'Transaction Search',
  },
  salesAnalysis: {
    key: 'sideMenu.salesAnalysis',
    defaultValue: 'Sales Analysis',
  },
  yearlyStockTake: {
    key: 'sideMenu.yearlyStockTake',
    defaultValue: 'Yearly Stock Take',
  },
  employees: {
    key: 'sideMenu.employees',
    defaultValue: 'Employees & Roles',
  },
  test: {
    key: 'sideMenu.test',
    defaultValue: 'Test',
  },
  development: {
    key: 'sideMenu.development',
    defaultValue: 'Development',
  },
  createAvatar: {
    key: 'sideMenu.createAvatar',
    defaultValue: 'Create avatar',
  },
  kpiTarget: {
    key: 'sideMenu.kpiTarget',
    defaultValue: 'KPI Targets',
  },
  soldProducts: {
    key: 'sideMenu.soldProducts',
    defaultValue: 'Sold Products',
  },
  productCategory: {
    key: 'sideMenu.productCategory',
    defaultValue: 'Product Category',
  },
  profitAndLoss: {
    key: 'sideMenu.profitAndLoss',
    defaultValue: 'Profit And Loss',
  },
  widgetAccessControl: {
    key: 'sideMenu.widgetAccessControl',
    defaultValue: 'Widget Access Control',
  },
  areaOverview: {
    key: 'sideMenu.areaOverview',
    defaultValue: 'Area Overview',
  },
  profile: {
    key: 'sideMenu.profile',
    defaultValue: 'Profile',
  },
  accessApproval: {
    key: 'sideMenu.accessApproval',
    defaultValue: 'Access Approvals',
  },
  areaResult: {
    key: 'sideMenu.areaResult',
    defaultValue: 'Area Result',
  },
  storesList: {
    key: 'sideMenu.storesList',
    defaultValue: 'Store Directory',
  },
  chatBoxPage: {
    key: 'sideMenu.chatBoxPage',
    defaultValue: 'Chat Box',
  },
  storeOverviewPage: {
    key: 'sideMenu.storeOverviewPage',
    defaultValue: 'Sales Overview',
  },
};

export const headerTranslations = {
  messages: {
    key: 'header.messages',
    defaultValue: 'Messages',
  },
  messageWithCount: {
    key: 'header.messageWithCount',
    defaultValue: 'Messages ({{count}})',
  },
  signout: {
    key: 'header.signout',
    defaultValue: 'Sign out',
  },
  signin: {
    key: 'header.signin',
    defaultValue: 'Sign in',
  },
};
